<template>
    <div class="form-group" :class="col">
        <label v-if="label" :for="forId">{{label}}</label>
        <input
                :value="value"
                :name="label"
                :id="forId"
                type="number"
                class="form-control"
                :class="inputClass"
                v-validate="required"
                :readonly="readonly"
                @input="$emit('input', $event.target.value)">
        <span v-if="errors.first(label)" class="small text-danger">Dit veld mag alleen cijfers en komma's bevatten.</span>
    </div>
</template>

<script>
    import {numberOnlyInput} from 'motivate-vue-util/src/lib/directives'

    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: [Number, String],
                default: null
            },
            col: String,
            label: String,
            forId: String,
            inputClass: String,
            required: {
                type: String,
                default: ''
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        directives: {
            numberOnlyInput
        },
        data() {
            return {

            }
        },
    }
</script>